import ic3Logo from "../../assets/ic3.png";
import outreachLogo from "../../assets/outreach.png";
import collegeBoardLogo from "../../assets/college board.png";
import britishCurriculumLogo from "../../assets/British Curriculum.png";
import nationalCurriculumLogo from "../../assets/National Curriculum.png";
import americanCurriculumLogo from "../../assets/American Curriculum.png";

const partners = [
  { id: "ic3", src: ic3Logo, alt: "IC3" },
  { id: "outreach", src: outreachLogo, alt: "The Outreach Collective" },
  { id: "college-board", src: collegeBoardLogo, alt: "College Board" },
  {
    id: "british",
    src: britishCurriculumLogo,
    alt: "Cambridge Assessment International Education",
  },
  {
    id: "national",
    src: nationalCurriculumLogo,
    alt: "NIOS National Institute of Open Schooling",
  },
  {
    id: "american",
    src: americanCurriculumLogo,
    alt: "NWAC Northwest Accreditation Commission",
  },
];

function Accreditation() {
  return (
    <section
      className="relative overflow-hidden border-y border-brand/10 bg-[#fafafa] py-14 sm:py-16 lg:py-20"
      aria-labelledby="home-accreditation-heading"
    >
      <div className="relative mx-auto max-w-7xl px-4 sm:px-8 md:px-10 lg:px-8">
        <header className="mx-auto max-w-3xl text-center">
          <p className="text-xs font-semibold uppercase tracking-[0.22em] text-brand sm:text-[0.8125rem]">
            Recognition
          </p>
          <h2
            id="home-accreditation-heading"
            className="mt-4 text-balance text-3xl font-bold tracking-tight text-ink sm:mt-5 sm:text-4xl md:text-[2.375rem] md:leading-tight"
          >
            Accreditation
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-pretty text-base leading-relaxed text-ink/65 sm:mt-5 sm:text-lg">
            Recognised qualifications and trusted partners that support your next step.
          </p>
        </header>

        <ul className="mt-10 grid list-none grid-cols-2 gap-6 sm:mt-12 sm:grid-cols-3 sm:gap-8 lg:grid-cols-6 lg:gap-6">
          {partners.map(({ id, src, alt }) => (
            <li
              key={id}
              className="flex min-h-[6.5rem] items-center justify-center rounded-2xl bg-white p-4 shadow-sm ring-1 ring-black/[0.06] sm:min-h-[7.5rem] sm:p-5"
            >
              <img
                src={src}
                alt={alt}
                className="h-20 w-full max-w-[200px] object-contain object-center sm:h-24 md:h-28"
                loading="lazy"
                decoding="async"
              />
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}

export default Accreditation;
